import axios from "./axiosinstance";

const GoogleApi = {
  status: () => axios.get("/google/status"),

  connect: () => axios.get("/google/connect"),

  disconnect: () => axios.delete("/google/disconnect"),
};

export default GoogleApi;